import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Grid, Navigation, Pagination } from "swiper/modules";
import { Swiper } from "swiper/react";
import Utils from "../../utils/utils";
import "./ExploreOtherOptionsSwiper.scss";
import { UI } from "../../config/ui";

const ExploreOtherOptionsSwiper: FcDiv = ({ children }) => {
  return (
    <div className="relative">
      <div className="mb-2 flex justify-end gap-[0.625rem]">
        <button className="button-prev custom-swiper-button-prev size-8 items-center rounded-full border border-[#DEDEDE]">
          <img
            className="mx-auto h-[0.8369rem] w-[0.4263rem]"
            src="../../../assets/icons/swiper_prev_arrow.svg"
            alt=""
          />
        </button>
        <button className="button-next custom-swiper-button-prev size-8 items-center rounded-full border border-[#DEDEDE]">
          <img
            className="mx-auto h-[0.8369rem] w-[0.4263rem]"
            src="../../../assets/icons/swiper_next_arrow.svg"
            alt=""
          />
        </button>
      </div>

      <Swiper
        grid={{
          rows: 1,
        }}
        slidesPerView={"auto"}
        spaceBetween={16}
        breakpoints={{
          [UI.sm]: {
            slidesPerView: 4,
            spaceBetween: Utils.remToPx(1.5),
          },
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Grid, Pagination, Navigation]}
        className="other-options-swiper prod-card-swiper"
        navigation={{
          nextEl: ".button-next",
          prevEl: ".button-prev",
        }}
      >
        {children}
      </Swiper>
    </div>
  );
};
export default ExploreOtherOptionsSwiper;
